import { FC, useCallback, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscription } from '../../../utils';
import {
    systemPushSubscriptionUnsubscribe,
    systemSetPushSubscription,
    systemSetPushSubscriptionPublicKey,
} from '../actions';
import { pushSubscription2FuntipPushSubscription } from '../sagas';
import { isLoggedInSelector, systemPushSubscriptionSelector } from '../selectors';
import { getPushNotificationApi } from '../systemConfig';

export const PushNotification: FC<{}> = () => {
    const api = getPushNotificationApi();

    const loggedIn = useSelector(isLoggedInSelector);
    const pushSubscription = useSelector(systemPushSubscriptionSelector);

    const publicKeyQuery = useQuery('publicKeyQuery', () => api.getPublicKey(), { refetchOnWindowFocus: false });

    const dispatch = useDispatch();

    const checkForLogout = useCallback(() => {
        if (!loggedIn && pushSubscription) {
            // we need to unsubscribe because there is no logged in user anymore
            dispatch(systemPushSubscriptionUnsubscribe());
        }
    }, [dispatch, loggedIn, pushSubscription]);

    // check every 10 minutes if the user is still logged in; if not, unsubscribe from push messages
    useEffect(() => {
        const interval = setInterval(checkForLogout, 10 * 60 * 1000);

        return () => clearInterval(interval);
    }, [checkForLogout]);

    useEffect(() => {
        getPushSubscription().then((sub) => {
            if (sub) {
                const funtipSub = pushSubscription2FuntipPushSubscription(sub);
                if (funtipSub) {
                    dispatch(systemSetPushSubscription(funtipSub));
                }
            }
        });
    }, [dispatch]);

    useEffect(() => {
        if (publicKeyQuery.isSuccess && publicKeyQuery.data && publicKeyQuery.data.message) {
            dispatch(systemSetPushSubscriptionPublicKey(publicKeyQuery.data.message));
        }
    }, [publicKeyQuery, dispatch]);

    return null;
};
